export default __webpack_public_path__ + "static/foundation_w.0969db88c186b1d8fa39e7b7d5b7b162.svg";